import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Flex,
  Text,
  Spinner,
  useDisclosure,
  useToast
} from '@chakra-ui/react'
import { FC, useCallback, useEffect, useMemo, useState } from 'react'
import { decodeToken } from 'react-jwt'
import { useImmer } from 'use-immer'

import useMrpPurchase from '@hook/mrp/use-purchase'

import TableGrid from '@component/Layout/TableGrid'

import suppliers from '@helper/suppliers'
import mrp from '@service/mrp'

import { IActionSapHistoric } from '@base/@types/components/Layout/Tools'
import { Pagination } from '@base/@types/providers/Parametrization/RevisionProvider'
import sapHistoricHeader from '@base/variables/headers/suppliers/saphistoric'

import LayoutToolsButton from '../Components/Button'
import ExportSapHistoric from './ExportSapHistoric'

const ActionSapHistoric: FC<IActionSapHistoric> = ({ code = '' }) => {
  const toast = useToast()

  const { isOpen, onOpen, onClose } = useDisclosure()
  const { handleUpdateData, params, handleLoading } = useMrpPurchase()
  const [errorMessage, setErrorMessage] = useState('')

  const headers = useMemo(() => sapHistoricHeader, [])
  const [rows, updateRows] = useImmer<any[]>([])
  const [pagination, updatePagination] = useImmer<Pagination>({
    actualPage: 0,
    rows: 0,
    totalPages: 0,
    totalRows: 0,
    skip: 0
  })

  const [loading, setLoadingSupply] = useState(true)
  const [error, setError] = useState(false)

  const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID
  const audience = process.env.REACT_APP_AUTH0_AUDIENCE
  const userInfos = JSON.parse(
    localStorage.getItem(
      `@@auth0spajs@@::${clientId}::${audience}::openid profile email offline_access`
    )
  )
  const decodedToken = decodeToken(userInfos?.body.access_token) as any
  const getData = useCallback(
    async (page = 0) => {
      setLoadingSupply(true)
      setError(false)
      const idUser =
        decodedToken?.role === 'Administrador' ? null : decodedToken?.userid
      try {
        const {
          data: { data, pagination }
        } = await mrp.getHistoricSap(code, page, 50, null, null, idUser)
        updatePagination(pagination)
        updateRows(draft => {
          return draft
            .filter((row: any) => row.id === 'null')
            .concat(suppliers.parseResultHistoric(data))
        })
      } catch (ex: any) {
        const msg =
          ex?.response?.data?.message || 'Erro inesperado ao buscar os dados.'

        setErrorMessage(msg)
        setError(true)
      }
      setLoadingSupply(false)
    },
    [code, updatePagination, updateRows]
  )

  useEffect(() => {
    if (isOpen && code !== '') {
      getData(1)
    }
  }, [isOpen, code, getData])

  return (
    <>
      <LayoutToolsButton label="Historico Pedido" onClick={onOpen} />
      <Modal isOpen={isOpen} onClose={onClose} size="6xl">
        <ModalOverlay />
        <ModalContent transition="all ease .3s">
          <ModalHeader bgColor="white">
            <Flex>
              <Text pt={2} pr={2}>
                Historico SAP
              </Text>
              <>
                <ExportSapHistoric code={code} days={30} />
              </>
            </Flex>
          </ModalHeader>

          <ModalCloseButton />
          <ModalBody bgColor="white">
            {error ? (
              <Flex
                flexDir="column"
                alignItems="center"
                justifyContent="center"
                h="380px"
              >
                <Text mb={4}>{errorMessage}</Text>

                <Button onClick={getData}>Tentar novamente</Button>
              </Flex>
            ) : loading ? (
              <Flex alignItems="center" justifyContent="center" h="380px">
                <Spinner />
              </Flex>
            ) : (
              <TableGrid
                id="table-suppliers"
                headers={headers}
                data={rows}
                height="360px"
                pagination={pagination}
                udatePageChange={getData}
                isPagedBack={true}
                isPaged={false}
              />
            )}
          </ModalBody>
          <ModalFooter justifyContent="center" bgColor="white"></ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}

export default ActionSapHistoric
